import {QueryStringParameters} from "@rsp/shared/util/query-string-parameters";


export class UrlBuilder {
  public url: string;
  public queryString: QueryStringParameters;
  constructor(
    private baseUrl: string,
    private action: string,
    queryString?: QueryStringParameters
  ) {
    this.url = [baseUrl, action].join('/');
    this.queryString = queryString || new QueryStringParameters();
  }
  public toString(): string {
    return this.url + (this.queryString.toString() ? '?' + this.queryString.toString():'');
  }
}
